import React, {useEffect, useState} from 'react';
import {useStores} from "../../../stores/Context";
import BtnAction from "../../../boiteAOutils/BtnAction";
import BtnPrimary from "../../../boiteAOutils/BtnPrimary";
import {createAxiosEntrepriseInstance} from "../../../axiosEntreprise";
import {Alert} from "react-bootstrap";

const WidgetBibliothequeImageUpload = (props) => {
    const {widgetStore, bibliothequeImagesStore} = useStores();
    const [image, setImage] = useState(null);
    const [file, setFile] = useState(null);
    const [error, setError] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const api = createAxiosEntrepriseInstance();

    useEffect(() => () => {
        if (image) URL.revokeObjectURL(image);
    }, [image]);

    const handleImageChange = (event) => {
        setImage(null);
        const selectedFile = event.target.files[0];

        if (!selectedFile) return;

        // Vérification du type
        if (!selectedFile.type || !selectedFile.type.startsWith("image/")) {
            setError("Le fichier sélectionné n’est pas une image valide !");
            return;
        }

        // Vérification de la taille : 10 Mo maximum, conforme à l'API.
        if (selectedFile.size === 0) {
            setError("Le fichier est vide !");
            return;
        }
        if (selectedFile.size > 10 * 1024 * 1024) {
            setError("Cette image dépasse la taille maximale autorisée de 10 Mo.");
            return;
        }

        // Crée l'URL pour affichage
        if (image) URL.revokeObjectURL(image);
        const imageUrl = URL.createObjectURL(selectedFile);
        setImage(imageUrl);
        setFile(selectedFile);
        setError("");
    };

    const handleUpload = async () => {
        setError('');

        if (!file) {
            setError("Sélectionnez une image d'abord !");
            return;
        }

        if (!file.type || !file.type.startsWith("image/")) {
            setError("Le fichier sélectionné n’est pas une image valide !");
            return;
        }

        if (file.size === 0) {
            setError("Le fichier est vide !");
            return;
        }
        if (file.size > 10 * 1024 * 1024) {
            setError("Cette image dépasse la taille maximale autorisée de 10 Mo.");
            return;
        }

        try {
            setIsUploading(true);
            const formData = new FormData();
            formData.append("file", file, file.name);
            formData.append("id_totem", widgetStore.idTotem);

            // L'instance entreprise ajoute le token d'espace courant.
            // Ne pas définir Content-Type manuellement : le navigateur ajoute la boundary multipart.
            await api.post('/api/bibliothequeImages/upload', formData);

            props.onAddImage();
            bibliothequeImagesStore.handleCloseUploadImage();
        
        } catch (error) {
            if (!error.response) {
                setError("Impossible de joindre le serveur. Vérifiez votre connexion puis réessayez.");
            } else if (error.response.status === 413) {
                setError("Cette image dépasse la taille maximale autorisée de 10 Mo.");
            } else {
                const validationError = error.response?.data?.errors?.file?.[0]
                    || error.response?.data?.errors?.id_totem?.[0];
                setError(validationError || error.response?.data?.message || "L’image n’a pas pu être enregistrée.");
            }
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <div className={"consigneModifyBody"} >

            <div className={"consigneModifyHeader"}>
                <h3 className={"consigneModifyTitleH3"}>
                    Importer une image
                </h3>
                <div onClick={() => bibliothequeImagesStore.handleCloseUploadImage()} style={{ cursor: "pointer", rotate: "180deg" }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B" stroke-width="2"/>
                        <line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B" stroke-width="2"/>
                        <line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B" stroke-width="2"/>
                    </svg>
                </div>
            </div>
            <div className={"consigneModifyHeaderSeparateur"}></div>

                <div>
                    <div className={"consigneModifyPhotoList"} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', margin: "2em 0", padding: '1em'}} >
                        {image && <img src={image} alt="Aperçu de l'image sélectionnée" className="w-48 h-48 object-cover rounded" style={{width: 'auto'}} />}
                        <input type="file" accept="image/*" onChange={handleImageChange} />
                    </div>


                    {
                        error && (
                            <Alert variant={"danger"}>{error}</Alert>
                        )
                    }
                    {image && (
                        <div className="mt-4">

                            <BtnPrimary
                                onClick={handleUpload}
                                disabled={isUploading}
                            >
                                {isUploading ? 'Enregistrement…' : 'Enregistrer'}
                            </BtnPrimary>
                        </div>
                    )}

                </div>
        </div>
    );
};

export default WidgetBibliothequeImageUpload;
